import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import { modalEventListener } from "../../../utils/ModalEventListener";
import SingleSelectDropDown from "../../../layouts/SingleSelectDropDown";
import {
  CANCELLED_TXN_REASON,
  TXN_REASON_TYPE,
  maxFileSize,
} from "../../../utils/constant";
import { useDropzone } from "react-dropzone";
import { ToastContainer, toast } from "react-toastify";
import { updateTransaction } from "../../../utils/bankbox";
import ModalWrapper from "../../../layouts/ModalWrapper";

const ManualActionModal = ({
  manualActionProps,
  bankBoxPanelState,
  setBankBoxPanelState,
  fetchListData,
  closeManualActionModal,
  showManualActionModal,
}) => {
  const ref = useRef();
  const [state, setState] = useState({
    reasonType: "",
    resubmitReason: "",
    utrNumber: "",
    comments: "",
    showResubmitReasonDiv: false,
    showCompleteTxnDiv: false,
    showComments: false,
    disableResubmitBtn: false,
    disableMarkAsCompletedBtn: false,
    file: "",
  });

  useEffect(() => {
    return modalEventListener(ref, closeManualActionModal);
  }, [closeManualActionModal]);

  useEffect(() => {
    if (state.file) toast(<Message />);
  }, [state.file]);

  const onDrop = (f) => {
    setState({ ...state, file: f[0] });
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: { "image/*": [] },
    maxFiles: 1,
    maxSize: maxFileSize,
    multiple: false,
  });

  const getNames = () => {
    return state.file ? state.file.name : "";
  };

  const Message = () => (
    <>
      <span className="glyphicon glyphicon-ok-sign"></span>
      {` ${getNames()}`} has been uploaded.
    </>
  );

  const handleInputChange = (e) => {
    const { value, name } = e.target;
    if (name === "reasonType") {
      if (["release_manually", "txn_resubmitted"].includes(value)) {
        state.showResubmitReasonDiv = true;
        state.showCompleteTxnDiv = false;
        state.showComments = false;
        state.disableMarkAsCompletedBtn = true;
        state.disableResubmitBtn = false;
      } else if (value === "Transaction Completed") {
        state.showResubmitReasonDiv = false;
        state.showCompleteTxnDiv = true;
        state.showComments = true;
        state.disableMarkAsCompletedBtn = false;
        state.disableResubmitBtn = true;
      }
    }

    if (name === "resubmitReason") {
      state.showComments = value === "Others";
    }

    setState({ ...state, [name]: value });
  };

  const handleManualSubmit = async () => {
    const { txnId, txnNo, reqType } = manualActionProps;
    let { reasonType, resubmitReason, comments } = state;
    toast.dismiss();

    if (!txnNo || !reqType) return;
    if (!reasonType)
      return toast.error("Please select action type", { theme: "colored" });
    if (!resubmitReason)
      return toast.error("Please select reason", { theme: "colored" });
    if (resubmitReason === "Others" && comments.trim() === "")
      return toast.error("Please enter other reason", { theme: "colored" });

    if (resubmitReason === "Others") {
      resubmitReason = `${resubmitReason} : ${comments}`;
    }

    await updateTransaction(
      txnId,
      txnNo,
      reqType,
      resubmitReason,
      reasonType,
      setBankBoxPanelState,
      fetchListData
    );
    setState({ ...state, reasonType: "", resubmitReason: "" });
  };

  const handleMarkAsCompletedSubmit = async () => {
    const { txnId, txnNo, reqType } = manualActionProps;
    let { reasonType, utrNumber, comments, file } = state;

    if (!txnNo || !reqType) return;
    if (!reasonType)
      return toast.error("Please select action type", { theme: "colored" });
    if (!utrNumber)
      return toast.error("Please Enter UTR Number", { theme: "colored" });
    if (!file)
      return toast.error("Please Add Attachment", { theme: "colored" });

    await updateTransaction(
      txnId,
      txnNo,
      reqType ? "txnCompleted" : "",
      comments,
      reasonType,
      setBankBoxPanelState,
      fetchListData,
      utrNumber,
      file
    );
    setState({
      ...state,
      reasonType: "",
      resubmitReason: "",
      utrNumber: "",
      file: "",
    });
  };

  return ReactDOM.createPortal(
    <ModalWrapper show={showManualActionModal} onClose={closeManualActionModal}>
      <div className="modal-wrapper">
        <ToastContainer
          closeOnClick={false}
          draggable={false}
          closeButton={false}
        />
        <div className="manual-action-modal-content" ref={ref}>
          <div className="modal-header">
            <button
              type="button"
              className="close"
              onClick={closeManualActionModal}
            >
              <span>&times;</span>
            </button>
            <h4 className="modal-title" id="nanualActionModal">
              Manual Actions
            </h4>
          </div>
          <div className="modal-body clearfix doc-upload-wrapper">
            <div className="form-group mrg-T15">
              <div className="row">
                <div className="col-md-6">
                  <label className="fnt14">
                    Select Action Type<span className="col-red">*</span>
                  </label>
                </div>
                <SingleSelectDropDown
                  dataArr={TXN_REASON_TYPE}
                  handleChange={(e) => handleInputChange(e)}
                  name="reasonType"
                  required={true}
                  value={state.reasonType}
                  divClassName="col-md-6"
                />
              </div>
            </div>
            <div className="form-group mrg-T15">
              {state.showResubmitReasonDiv ? (
                <div id="txnRsnType">
                  <div className="row">
                    <div className="col-md-6">
                      <label className="fnt14">
                        Select Reason For Resubmit
                        <span className="col-red">*</span>
                      </label>
                    </div>
                    <SingleSelectDropDown
                      dataArr={CANCELLED_TXN_REASON}
                      handleChange={(e) => handleInputChange(e)}
                      name="resubmitReason"
                      required={true}
                      value={state.resubmitReason}
                      divClassName="col-md-6"
                    />
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>

            {state.showCompleteTxnDiv ? (
              <div id="completeTxn">
                <div className="form-group mrg-T15">
                  <div className="row">
                    <div className="col-md-6">
                      <label className="fnt14">
                        UTR Number<span className="col-red">*</span>
                      </label>
                    </div>
                    <div className="col-md-6">
                      <input
                        type="text"
                        name="utrNumber"
                        id="utrNumber"
                        className="form-control"
                        onChange={(e) => handleInputChange(e)}
                        value={state.utrNumber}
                      />
                    </div>
                  </div>
                </div>

                <div className="form-group mrg-T15">
                  <div className="row">
                    <div className="col-md-12">
                      <label className="fnt14">
                        Attach Screenshot<span className="col-red">*</span>
                      </label>
                    </div>
                    <div className="col-md-12">
                      <div>
                        <form
                          className="dropzone dd-zone dz-clickable"
                          style={{ minHeight: "150px" }}
                          id="utr_uploader"
                        >
                          <div
                            className="dz-default dz-message"
                            {...getRootProps()}
                          >
                            <input {...getInputProps()} />
                            Drop files here to upload
                          </div>
                        </form>
                        <div className="clearfix btn-upload-wrapper">
                          <div className="ufn-wrapr">
                            <p className="ufn" id="caseFileUploadDiv">
                              {(() => {
                                const names = getNames();
                                return names.length > 0 ? (
                                  <>
                                    <span className="fa fa-file-excel-o"></span>
                                    {` ${names}`}
                                  </>
                                ) : (
                                  ""
                                );
                              })()}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}

            {state.showComments ? (
              <div className="form-group mrg-T15">
                <div id="txnRemark">
                  <label className="fnt14">Comments</label>
                  <textarea
                    id="txnRsn"
                    name="comments"
                    className="form-control"
                    maxLength="450"
                    onChange={(e) => handleInputChange(e)}
                    value={state.comments}
                  ></textarea>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn rc-btn_rset pad-L20 pad-R20 actionBtn"
              onClick={closeManualActionModal}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn rc-btn_danger btn-lg actionBtn"
              id="manualBtn"
              disabled={state.disableResubmitBtn}
              onClick={handleManualSubmit}
            >
              Resubmit & Release Manually
            </button>
            <button
              type="button"
              className="btn rc-btn_primary btn-lg actionBtn"
              id="markCompletedBtn"
              disabled={state.disableMarkAsCompletedBtn}
              onClick={handleMarkAsCompletedSubmit}
            >
              Mark as Completed
            </button>
          </div>
        </div>
      </div>
    </ModalWrapper>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default ManualActionModal;
